<template>
  <div>
    <input v-model="orderGroupId" />
    <van-button @click="sub">发送请求</van-button>
  </div>
</template>

<script>
export default {
  data(){
    return {
      orderGroupId:""
    }
  },
  methods:{
    sub(){
      let data = {
        orderGroupId:this.orderGroupId
      }
      this.Api({
        url:"api/orderRefund",
        method:"POST",
        data
      }).then(res => {
        alert(JSON.stringify(res))
      }).catch(err => {
        alert("后台报错了！！！！！！"+JSON.stringify(err) )
      })
    }
  }
}
</script>

<style scoped>

</style>
